var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4725 5.38991C8.83702 5.38991 5.88991 8.33702 5.88991 11.9725V28.0275C5.88991 31.663 8.83702 34.6101 12.4725 34.6101H28.5275C32.163 34.6101 35.1101 31.663 35.1101 28.0275V11.9725C35.1101 8.33702 32.163 5.38991 28.5275 5.38991H12.4725ZM3 11.9725C3 6.74097 7.24097 2.5 12.4725 2.5H28.5275C33.759 2.5 38 6.74097 38 11.9725V28.0275C38 33.259 33.759 37.5 28.5275 37.5H12.4725C7.24097 37.5 3 33.259 3 28.0275V11.9725Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2998 15.007C20.2643 14.8534 19.2067 15.0303 18.2775 15.5125C17.3483 15.9946 16.5947 16.7575 16.1241 17.6926C15.6534 18.6277 15.4896 19.6874 15.6559 20.7209C15.8222 21.7545 16.3102 22.7093 17.0505 23.4496C17.7907 24.1898 18.7455 24.6778 19.7791 24.8441C20.8126 25.0104 21.8723 24.8466 22.8074 24.3759C23.7425 23.9053 24.5054 23.1517 24.9875 22.2225C25.4697 21.2933 25.6466 20.2357 25.493 19.2002C25.3364 18.1439 24.8442 17.166 24.0891 16.4109C23.334 15.6558 22.3561 15.1636 21.2998 15.007ZM16.9465 12.9473C18.4152 12.1852 20.0869 11.9056 21.7237 12.1484C23.3933 12.3959 24.9391 13.1739 26.1326 14.3674C27.3261 15.561 28.1041 17.1067 28.3517 18.7763C28.5944 20.4131 28.3148 22.0848 27.5527 23.5535C26.7906 25.0223 25.5847 26.2133 24.1067 26.9573C22.6286 27.7012 20.9536 27.9602 19.32 27.6973C17.6863 27.4344 16.177 26.6631 15.007 25.493C13.8369 24.323 13.0656 22.8138 12.8027 21.1801C12.5398 19.5464 12.7988 17.8714 13.5427 16.3933C14.2867 14.9153 15.4777 13.7094 16.9465 12.9473Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8853 11.1697C27.8853 10.3717 28.5322 9.72477 29.3303 9.72477H29.3463C30.1444 9.72477 30.7913 10.3717 30.7913 11.1697C30.7913 11.9678 30.1444 12.6147 29.3463 12.6147H29.3303C28.5322 12.6147 27.8853 11.9678 27.8853 11.1697Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramCampaign);
export default __webpack_public_path__ + "static/media/instagram-campaign.3f7bb389f80dc309cf52e32cfc6a2fc5.svg";
export { ForwardRef as ReactComponent };